import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.074}
    height={26.456}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9692 17010"
    {...props}
  >
    <defs>
      {/* <style>{".fil1{fill:#1c1b17}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528237922208">
        <path
          d="M517 16053h8659c-32 266-285 449-586 449H1101c-298 0-551-182-584-449zm-13-9901 8687-3 1 9644-8688 2V6152zm8687-1963 1 1703-1699-2-6989-2c11-1481 0-2967 0-4448 0-147-16-401 22-532 151-524 802-397 1277-397h6641c193 0 333-8 483 80 102 61 201 183 240 315 49 163 25 1889 25 2201 0 352 13 735-1 1082zM928 264c-224 39-390 146-505 292-142 181-178 350-178 635v14452c0 287-25 472 107 704 90 160 235 295 439 366 237 84 1242 46 1568 46h5631c211 0 609 22 795-14 232-44 384-167 492-298 135-163 171-369 171-629-14-4811 0-9638 0-14452 0-259 17-492-103-697-95-161-232-298-435-368-257-89-1221-49-1563-49H1715c-217 0-591-21-787 12z"
          style={{
            fill: "#000",
            // stroke: "#000",
            strokeWidth: 486.016,
          }}
          className="fill"
        />
        <rect
          width={871}
          height={2659}
          x={695}
          y={2521}
          className="fil1"
          rx={4860}
          ry={4860}
        />
        <rect
          width={871}
          height={3924}
          x={695}
          y={6680}
          className="fil1"
          rx={4860}
          ry={7170}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
